// client/src/pages/ShopPOS/components/CashInputModal.tsx
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface CashInputModalProps {
  show: boolean;
  cartTotal: number;
  getCurrencySymbol: () => string;
  onConfirm: (cashReceived: number) => void;
  onBack: () => void;
}

export function CashInputModal({
  show,
  cartTotal,
  getCurrencySymbol,
  onConfirm,
  onBack,
}: CashInputModalProps) {
  const [cashReceived, setCashReceived] = useState("");
  const [changeAmount, setChangeAmount] = useState(0);

  useEffect(() => {
    if (!show) {
      setCashReceived("");
      setChangeAmount(0);
    }
  }, [show]);

  const handleCashChange = (value: string) => {
    setCashReceived(value);
    const received = parseFloat(value) || 0;
    setChangeAmount(received > cartTotal ? received - cartTotal : 0);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[70] p-4">
      <div className="bg-background rounded-lg p-6 w-full max-w-sm">
        <h3 className="text-lg font-bold mb-4">Pago en Efectivo</h3>
        <div className="space-y-4">
          <div>
            <div className="text-center mb-2">
              <div className="text-sm text-muted-foreground">Total a pagar</div>
              <div className="text-3xl font-bold">
                {getCurrencySymbol()}
                {cartTotal.toFixed(2)}
              </div>
            </div>

            <label className="text-sm font-medium mb-1 block">
              Monto Recibido
            </label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">
                {getCurrencySymbol()}
              </span>
              <Input
                type="number"
                placeholder="0.00"
                className="pl-8 text-lg"
                value={cashReceived}
                onFocus={(e) => {
                  if (e.target.value === "0" || e.target.value === "0.00") {
                    e.target.value = "";
                  }
                }}
                onChange={(e) => handleCashChange(e.target.value)}
                min="0"
                step="0.01"
                autoFocus
              />
            </div>
          </div>

          {changeAmount > 0 && (
            <div className="bg-green-50 border border-green-200 rounded p-3">
              <div className="text-sm text-green-800 font-medium">
                Cambio a entregar:
              </div>
              <div className="text-xl font-bold text-green-900">
                {getCurrencySymbol()}
                {changeAmount.toFixed(2)}
              </div>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-2 pt-2">
            <Button
              className="w-full"
              onClick={() => onConfirm(parseFloat(cashReceived) || 0)}
              disabled={!cashReceived || parseFloat(cashReceived) < cartTotal}
            >
              Confirmar Pago
            </Button>
            <Button variant="outline" className="w-full" onClick={onBack}>
              Volver
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
